import { useEffect } from "react";
import { useAtom, useAtomValue } from "@effect-atom/atom-react";
import { Header } from "./Header";
import { EditorPanel } from "./EditorPanel";
import { ResultPanel } from "./ResultPanel";
import { UnifiedPanel } from "./UnifiedPanel";
import { Splitter } from "./Splitter";
import { StatusBar } from "./StatusBar";
import { useAutoTransform } from "../hooks/useAutoTransform";
import { useDarkMode } from "../hooks/useDarkMode";
import { isMobileViewAtom, splitPositionAtom } from "../atoms";

const BREAKPOINT = 1024;

export function App() {
  useAutoTransform();
  useDarkMode();

  const [isMobileView, setIsMobileView] = useAtom(isMobileViewAtom);
  const splitPosition = useAtomValue(splitPositionAtom);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < BREAKPOINT);
    };

    // Set initial value
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsMobileView]);

  return (
    <>
      <Header />
      <div className="main-container">
        {isMobileView ? (
          <UnifiedPanel />
        ) : (
          <>
            <div
              className="left-panel-wrapper"
              style={{ width: `${splitPosition}%` }}
            >
              <EditorPanel />
            </div>
            <Splitter />
            <div
              className="right-panel-wrapper"
              style={{ width: `${100 - splitPosition}%` }}
            >
              <ResultPanel />
            </div>
          </>
        )}
      </div>
      <StatusBar />
    </>
  );
}
